// Arquivo: UserBalance.tsx
import { useEffect, useState } from 'react'
import { useAuth } from 'src/hooks/auth'
import { getBalance } from 'src/requests/transfeera/get-balance'
import { service } from 'src/services/ajio'
import { currencyFormat } from 'src/utils/currencyFormat'
import YellowBagOfMoney from '../../../assets/bagOfMoney.svg'
import './../style.css'
import {
  ButtonEyeVisibility,
  EyeDisabledIcon,
  EyeEnabledIcon,
} from './UserBalance.styles'

export type CustomExtract = {
  in: number
  out: number
}

export function UserBalance() {
  const [transactionsIn, setTransactionsIn] = useState<any[]>([])
  const [transactionsOut, setTransactionsOut] = useState<any[]>([])
  const [customExtract, setCustomExtract] = useState<CustomExtract>({
    in: 0,
    out: 0,
  })
  const { account, user } = useAuth()
  const [balance, setBalance] = useState(0)

  const [isBalanceVisible, setIsBalanceVisible] = useState(() => {
    const visible = localStorage.getItem('visible')

    if (visible && visible === 'true') {
      return true
    } else {
      return false
    }
  })

  ///////////////

  // Busca apenas transações do dia atual
  const findDashboardForToday = async () => {
    const today = new Date()
    const start_date = new Date(today.setHours(0, 0, 0, 0)) // Início do dia
    const end_date = new Date(today.setHours(23, 59, 59, 999)) // Fim do dia

    try {
      const { data } = await service.get('/dashboard/custom-extract', {
        params: {
          end_date,
          start_date,
        },
      })
      setCustomExtract(data)

      const response = await service.get(`/transactions`, {
        params: {
          end: end_date,
          start: start_date,
        },
      })

      const transactions = response.data.transactions.data

      const filterTransactionsIn = []
      const filterTransactionsOut = []

      for (let i = 0; i < transactions.length; i++) {
        if (
          new Date(transactions[i].created_at) <= end_date &&
          transactions[i].status === 'done'
        ) {
          if (transactions[i].direction === 'in') {
            filterTransactionsIn.push(transactions[i])
          } else {
            filterTransactionsOut.push(transactions[i])
          }
        }
      }
      setTransactionsOut(filterTransactionsOut)
      setTransactionsIn(filterTransactionsIn)
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
    }
  }

  const getBalanceAccount = async () => {
    const balance = await getBalance()
    console.log('balance', balance)
    if (balance?.value) {
      setBalance(balance?.value)
    } else {
      setBalance(0)
    }
  }

  useEffect(() => {
    findDashboardForToday()
    getBalanceAccount()
  }, [])

  /////////////////
  function getGreetingMessage(name: string): string {
    const currentHour = new Date().getHours()

    if (currentHour >= 5 && currentHour < 12) {
      return `Bom dia, ${name}`
    }
    if (currentHour >= 12 && currentHour < 18) {
      return `Boa tarde, ${name}`
    }
    return `Boa noite, ${name}`
  }

  // function formatValueToBRL(value: number): string {
  // 	return value.toLocaleString("pt-BR", {
  // 		style: "currency",
  // 		currency: "BRL",
  // 	});
  // }

  const handleBalanceAccounttoggle = () => {
    localStorage.setItem('visible', (!isBalanceVisible).toString())
    setIsBalanceVisible((state) => !state)
  }

  const getMaskedBalance = (balance: number | string) => {
    return '***'
  }

  return (
    <div className="balance-card border-radius-container flex flex-col bg-[#FBFAFA] border border-[#818181] shadow-md ">
      <div className="flex items-center justify-between">
        <h4 className="title-text">{`${getGreetingMessage(user.name)}!`}</h4>
        <ButtonEyeVisibility onClick={handleBalanceAccounttoggle} type="button">
          {isBalanceVisible ? <EyeDisabledIcon /> : <EyeEnabledIcon />}
        </ButtonEyeVisibility>
      </div>
      <div className="flex items-center justify-between h-full">
        <div className="flex items-center justify-start gap-sale">
          <img className="sale-icon" src={YellowBagOfMoney} alt="" />
          <div className="flex flex-col justify-start items-start">
            <span className="p-texte text-[#718ebf]">Meu saldo</span>
            <span className="font-bold total-balance">
              {isBalanceVisible
                ? currencyFormat(balance)
                : `R$ ${getMaskedBalance(balance)}`}{' '}
            </span>
          </div>
        </div>

        <hr className="border-balance" />

        <div className="flex flex-col wrapper-total-gap">
          <div className="flex items-center justify-between total-gap">
            <span className="text-[#718ebf] p-texte">Entrada:</span>
            <span className="text-[#16dbaa] total-balance font-bold">
              {isBalanceVisible
                ? currencyFormat(customExtract.in)
                : `R$ ${getMaskedBalance(customExtract.in)}`}
            </span>
          </div>
          <div className="flex items-center justify-between total-gap">
            <span className="text-[#718ebf] p-texte">Saída:</span>
            <span className="text-[#FF4B4A] total-balance font-bold">
              {isBalanceVisible
                ? currencyFormat(customExtract.out)
                : `R$ ${getMaskedBalance(customExtract.out)}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
